import { SvgProps } from "../../types";

const Note = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="none"
    {...props}>
    <path
      fill="#AEB3CB"
      d="M6.255 9.667h1.2v-3.6h-1.2v3.6Zm.6-4.8a.58.58 0 0 0 .428-.173.58.58 0 0 0 .172-.427.58.58 0 0 0-.172-.428.58.58 0 0 0-.428-.172.58.58 0 0 0-.427.172.58.58 0 0 0-.173.428c0 .17.058.312.173.427a.58.58 0 0 0 .427.173Zm0 7.8c-.83 0-1.61-.158-2.34-.473a6.06 6.06 0 0 1-1.905-1.282 6.06 6.06 0 0 1-1.282-1.905 5.843 5.843 0 0 1-.473-2.34c0-.83.158-1.61.473-2.34A6.06 6.06 0 0 1 2.61 2.422a6.06 6.06 0 0 1 1.905-1.283 5.842 5.842 0 0 1 2.34-.472c.83 0 1.61.157 2.34.472A6.06 6.06 0 0 1 11.1 2.422a6.06 6.06 0 0 1 1.283 1.905c.315.73.472 1.51.472 2.34 0 .83-.157 1.61-.472 2.34a6.06 6.06 0 0 1-1.283 1.905 6.06 6.06 0 0 1-1.905 1.282c-.73.315-1.51.473-2.34.473Zm0-1.2c1.34 0 2.475-.465 3.405-1.395.93-.93 1.395-2.065 1.395-3.405 0-1.34-.465-2.475-1.395-3.405-.93-.93-2.065-1.395-3.405-1.395-1.34 0-2.475.465-3.405 1.395-.93.93-1.395 2.065-1.395 3.405 0 1.34.465 2.475 1.395 3.405.93.93 2.065 1.395 3.405 1.395Z"
    />
  </svg>
);
export default Note;
